import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-section-title',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './section-title.component.html',
  styleUrls: ['./section-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionTitleComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() alignment: 'left' | 'center' = 'center';
  @Input() theme: 'light' | 'dark' = 'light'; // Text color adaptation
}
